import React, { useEffect, useState } from 'react';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

// Função utilitária para chamadas da API com fallback
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const urls = [
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`
  ];

  for (const url of urls) {
    try {
      console.log(`Tentando ${method} em: ${url}`);
      const config = {
        method,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      const token = getAuthToken();
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      
      if (data && (method === 'POST' || method === 'PUT')) {
        config.body = JSON.stringify(data);
      }

      const response = await fetch(url, config);
      
      if (response.ok) {
        console.log(`✅ Sucesso em: ${url}`);
        if (method === 'DELETE' || response.status === 204) {
          return { success: true };
        }
        return await response.json();
      }
      console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
    } catch (error) {
      console.log(`❌ Erro em: ${url} - ${error.message}`);
    }
  }
  
  throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
};

export default function PopupEditarOportunidade({ oportunidadeId, onClose }) {
  const [dadosOportunidade, setDadosOportunidade] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [mostrarSucesso, setMostrarSucesso] = useState(false);
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
  
  const [form, setForm] = useState({
    id: '',
    titulo: '',
    clienteId: '',
    clienteNome: '',
    clienteEndereco: '',
    clienteCelular: '',
    clienteEmail: '',
    descricao: '',
    status: '',
    dataCriacao: ''
  });

  // Lista de status disponíveis
  const statusDisponiveis = [
    'Em Prospecção',
    'Qualificada',
    'Proposta Enviada',
    'Em Negociação',
    'Fechada - Ganha',
    'Fechada - Perdida',
    'Cancelada'
  ];

  useEffect(() => {
    async function fetchOportunidade() {
      try {
        setLoading(true);
        setError('');
        console.log('Buscando oportunidade com ID:', oportunidadeId);
        
        const data = await apiCall(`Oportunidade/${oportunidadeId}`);
        console.log('✅ Dados da oportunidade carregados:', data);
        
        // Formatação da data se necessário
        let dataCriacao = data.dataCriacao;
        if (dataCriacao && dataCriacao.includes('T')) {
          dataCriacao = dataCriacao.split('T')[0];
        }
        
        // Preenche os valores do formulário com os dados da oportunidade
        setForm({
          id: data.id || '',
          titulo: data.oportunidade_Titulo || data.titulo || '',
          clienteId: data.clienteId || '',
          clienteNome: data.clienteNome || '',
          clienteEndereco: data.clienteEndereco || '',
          clienteCelular: data.clienteCelular || '',
          clienteEmail: data.clienteEmail || '',
          descricao: data.descricao || '',
          status: data.status || 'Em Prospecção',
          dataCriacao: dataCriacao || ''
        });
        
        setDadosOportunidade(data);
        
      } catch (e) {
        console.error('❌ Erro ao buscar dados da oportunidade:', e);
        setError(`Erro ao carregar dados da oportunidade: ${e.message}`);
      } finally {
        setLoading(false);
      }
    }
    
    if (oportunidadeId) {
      fetchOportunidade();
    }
  }, [oportunidadeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Verificar se o botão está desabilitado
    if (botaoDesabilitado) {
      return;
    }
    
    setSalvando(true);
    setError('');

    // Validações
    if (!form.titulo.trim()) {
      setError('Título é obrigatório.');
      setSalvando(false);
      return;
    }

    if (!form.descricao.trim()) {
      setError('Descrição é obrigatória.');
      setSalvando(false);
      return;
    }

    // Preparar payload com campos exatos do backend
    const oportunidadePayload = {
      id: parseInt(form.id),
      clienteId: parseInt(form.clienteId),
      titulo: form.titulo.trim(),
      descricao: form.descricao.trim(),
      status: form.status || 'Em Prospecção',
      dataCriacao: form.dataCriacao || new Date().toISOString().split('T')[0]
    };

    try {
      console.log('=== DEBUG EDIÇÃO OPORTUNIDADE PAYLOAD ===');
      console.log('Payload que será enviado via PUT:', oportunidadePayload);
      console.log('URL: Oportunidade/' + oportunidadeId);

      const resultado = await apiCall(`Oportunidade/${oportunidadeId}`, 'PUT', oportunidadePayload);
      console.log('✅ Oportunidade atualizada com sucesso:', resultado);
      
      // ✅ SUCESSO - Mostrar notificação e fechar após 2 segundos
      setMostrarSucesso(true);
      
      setTimeout(() => {
        setMostrarSucesso(false);
        onClose();
        // Recarregar a página para atualizar a lista
        window.location.reload();
      }, 2000);
      
    } catch (e) {
      console.error('❌ Erro ao editar oportunidade:', e);
      setError(`Erro ao salvar oportunidade: ${e.message}`);
      
      // ❌ ERRO - Desabilitar botão por 5 segundos
      setBotaoDesabilitado(true);
      setTimeout(() => {
        setBotaoDesabilitado(false);
      }, 5000);
    } finally {
      setSalvando(false);
    }
  };

  if (loading) {
    return (
      <div className="popup-agendamento-overlay">
        <div className="popup-agendamento" style={{ 
          position: 'relative', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '200px',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          <div style={{ textAlign: 'center', color: 'rgb(235, 133, 0)', fontSize: '18px' }}>
            Carregando dados da oportunidade...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="popup-agendamento-overlay" onClick={onClose}>
      <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ 
        position: 'relative', 
        maxWidth: '700px', 
        maxHeight: '90vh', 
        overflowY: 'auto',
        margin: '0 auto'
      }}>
        <button className="popup-fechar-btn" onClick={onClose} aria-label="Fechar">×</button>
        <div className="popup-agendamento-centro">
          <div className="popup-titulo-laranja" style={{ fontSize: '20px', marginBottom: '15px' }}>
            Editar Oportunidade
          </div>
          
          <form onSubmit={handleSubmit} style={{
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            width: '100%',
            fontFamily: 'Arial, sans-serif',
            boxSizing: 'border-box'
          }}>
            
            {/* Informações do Cliente */}
            {form.clienteNome && (
              <div style={{
                backgroundColor: '#f5f5f5',
                padding: '10px',
                borderRadius: '6px',
                marginBottom: '15px',
                border: '1px solid #ddd',
                fontSize: '12px'
              }}>
                <h3 style={{ color: 'rgb(235, 133, 0)', marginBottom: '8px', fontSize: '14px' }}>
                  Cliente da Oportunidade
                </h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '12px' }}>
                  <div><strong>Nome:</strong> {form.clienteNome}</div>
                  <div><strong>Email:</strong> {form.clienteEmail}</div>
                  <div><strong>Telefone:</strong> {form.clienteCelular}</div>
                  <div><strong>Endereço:</strong> {form.clienteEndereco}</div>
                </div>
              </div>
            )}

            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '15px'
            }}>
              
              {/* Campo Cliente ID (readonly) */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                  ID do Cliente
                </label>
                <input
                  type="number"
                  name="clienteId"
                  value={form.clienteId}
                  readOnly
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    fontSize: '14px',
                    width: '100%',
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Campo Status */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                  Status
                </label>
                <select
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    fontSize: '14px',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                >
                  {statusDisponiveis.map(status => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>

              {/* Campo Título */}
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                  Título da Oportunidade *
                </label>
                <input
                  type="text"
                  name="titulo"
                  value={form.titulo}
                  onChange={handleChange}
                  placeholder="Digite o título da oportunidade"
                  required
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    fontSize: '14px',
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Campo Descrição */}
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                  Descrição *
                </label>
                <textarea
                  name="descricao"
                  value={form.descricao}
                  onChange={handleChange}
                  placeholder="Descreva detalhadamente a oportunidade"
                  required
                  rows="3"
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    fontSize: '14px',
                    width: '100%',
                    maxWidth: '100%',
                    resize: 'vertical',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Campo Data de Criação */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                  Data de Criação
                </label>
                <input
                  type="date"
                  name="dataCriacao"
                  value={form.dataCriacao}
                  onChange={handleChange}
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    fontSize: '14px',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>
            
            {/* Exibir erros */}
            {error && (
              <div style={{ 
                marginTop: '15px', 
                padding: '8px', 
                backgroundColor: '#ffe6e6', 
                border: '1px solid #ff9999', 
                borderRadius: '5px',
                color: '#cc0000',
                fontSize: '13px'
              }}>
                {error}
              </div>
            )}
            
            {/* Botões */}
            <div className="oportunidade-form-botoes">
              <button
                type="submit"
                className="oportunidade-form-btn-salvar"
                disabled={salvando || botaoDesabilitado}
                style={{
                  backgroundColor: (salvando || botaoDesabilitado) ? '#ccc' : 'rgb(235, 133, 0)',
                  opacity: botaoDesabilitado ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!salvando && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(250, 178, 65)';
                }}
                onMouseLeave={(e) => {
                  if (!salvando && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(235, 133, 0)';
                }}
              >
                {botaoDesabilitado ? 'Aguarde 5 segundos...' : (salvando ? 'Salvando...' : 'Atualizar Oportunidade')}
              </button>
              
              <button
                type="button"
                className="oportunidade-form-btn-cancelar"
                onClick={onClose}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
        
        {/* Notificação de sucesso */}
        {mostrarSucesso && (
          <div style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'rgb(235, 133, 0)',
            padding: '15px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            fontSize: '16px',
            fontWeight: '600',
            zIndex: 9999,
            animation: 'fadeInOut 2.5s ease-in-out forwards',
            border: '2px solid rgb(235, 133, 0)'
          }}>
            Oportunidade atualizada com sucesso!
          </div>
        )}

        <style jsx>{`
          @keyframes fadeInOut {
            0% {
              opacity: 0;
              transform: translateX(-50%) translateY(-20px);
            }
            15% {
              opacity: 1;
              transform: translateX(-50%) translateY(0px);
            }
            85% {
              opacity: 1;
              transform: translateX(-50%) translateY(0px);
            }
            100% {
              opacity: 0;
              transform: translateX(-50%) translateY(-20px);
            }
          }
        `}</style>
      </div>
    </div>
  );
}
